(function (global, doc) {
  'use strict';
  if (global.ArtworkDawn) return;
  var sessions = new Map(), bound = new WeakSet(), locked = new Map(), scheduled = false;
  function config() {
    var el = doc.querySelector('[data-artwork-config]');
    return el ? JSON.parse(el.textContent) : null;
  }
  function imprint(scope) {
    var groups = scope.querySelectorAll('fieldset.product-form__input');
    for (var group of groups) {
      var legend = group.querySelector('legend');
      if (legend && /imprint/i.test(legend.textContent)) {
        var selected = group.querySelector('input:checked, select');
        return selected ? selected.value.trim() : '';
      }
    }
    var dropdowns = scope.querySelectorAll('.product-form__input--dropdown');
    for (var dropdown of dropdowns) {
      var label = dropdown.querySelector('label');
      if (label && /imprint/i.test(label.textContent)) {
        var choice = dropdown.querySelector('select'); return choice ? choice.value.trim() : '';
      }
    }
    var select = scope.querySelector('select[name*="Imprint"]');
    return select ? select.value.trim() : '';
  }
  function blank(value) { return !value || value.toLowerCase() === 'blank'; }
  function busy() { return Array.from(sessions.values()).some(function (s) { return s.getState().busy; }); }
  function lock() {
    var inFlight = busy();
    doc.querySelectorAll('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] input[type="submit"]').forEach(function (b) {
      if (inFlight) {
        if (!locked.has(b)) {
          var state = {nativeDisabled:b.disabled};
          state.observer = new MutationObserver(function (records) {
            if (records.length) state.nativeDisabled = b.disabled;
            preserveNative(b, state);
          });
          state.observer.observe(b, {attributes:true,attributeFilter:['disabled']});
          locked.set(b, state);
        }
        preserveNative(b, locked.get(b));
      } else if (locked.has(b)) {
        var prior = locked.get(b);
        if (prior.observer.takeRecords().length) prior.nativeDisabled = b.disabled;
        prior.observer.disconnect();
        b.disabled = prior.nativeDisabled || b.getAttribute('aria-disabled') === 'true';
        locked.delete(b);
      }
    });
    for (var b of locked.keys()) if (!b.isConnected) { locked.get(b).observer.disconnect(); locked.delete(b); }
  }
  function preserveNative(button, state) {
    if (state.observer.takeRecords().length) state.nativeDisabled = button.disabled;
    if (!button.disabled) state.nativeDisabled = false;
    button.disabled = true;
    state.observer.takeRecords(); // discard only our own lock write
  }
  function render(box, session) {
    var st = session.getState(), scope = box.closest('product-info') || box.closest('section') || doc;
    box.hidden = blank(imprint(scope));
    box.dataset.phase = st.phase || (st.busy ? 'uploading' : st.artwork ? 'complete' : 'idle');
    var nativeError = scope.querySelector('.product-form__error-message-wrapper .icon-error circle[fill]');
    if (nativeError) box.style.setProperty('--artwork-error-color', nativeError.getAttribute('fill'));
    var percent = box.querySelector('[data-artwork-percent]');
    if (percent) percent.textContent = String(st.progress || 0) + '%';
    var change = box.querySelector('[data-artwork-change]');
    if (change) change.hidden = !st.artwork;
    var choose = box.querySelector('[data-artwork-choose]');
    if (choose) choose.hidden = !!st.artwork;
    box.querySelector('[data-artwork-status]').textContent = st.artwork && st.phase === 'complete' ? '' : (st.status || 'No file selected');
    box.querySelector('progress').value = st.progress;
    var preview = box.querySelector('[data-artwork-preview]');
    var stamp = st.preview ? (st.preview.blob || st.preview.name) : '';
    if (preview.dataset.stamp !== stamp) {
      preview.dataset.stamp = stamp; preview.replaceChildren();
      if (st.preview) {
        if (st.preview.blob) {
          var img = doc.createElement('img'); img.src = st.preview.blob; img.alt = st.preview.name;
          img.style.maxWidth = '32px'; img.style.maxHeight = '32px'; preview.appendChild(img);
        } else {
          var badge = doc.createElement('strong'); badge.className = 'artwork-picker__badge'; badge.textContent = st.preview.ext.toUpperCase(); preview.appendChild(badge);
        }
        var label = doc.createElement('div'); label.textContent = st.preview.name; preview.appendChild(label);
      }
    }
  }
  function mount() {
    var cfg = config(); if (!cfg || !global.ArtworkUpload) return;
    doc.querySelectorAll('[data-artwork-upload]').forEach(function (box) {
      var id = box.dataset.productId;
      if (!sessions.has(id)) {
        var session = global.ArtworkUpload.create(cfg); sessions.set(id, session);
        session.subscribe(function () { repaint(); });
      }
      var session = sessions.get(id), input = box.querySelector('input[type="file"]');
      input.accept = cfg.acceptExts.map(function (e) { return '.' + e; }).join(',');
      if (!bound.has(input)) {
        bound.add(input);
        input.addEventListener('click', session.prime);
        input.addEventListener('change', function () { session.select(input.files && input.files[0]).then(function () { input.value = ''; }); });
      }
      render(box, session);
    });
    lock();
  }
  function repaint() {
    doc.querySelectorAll('[data-artwork-upload]').forEach(function (box) {
      var session = sessions.get(box.dataset.productId); if (session) render(box, session);
    });
    lock();
  }
  doc.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (busy()) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    form.querySelectorAll('[data-artwork-property]').forEach(function (n) { n.remove(); });
    var scope = form.closest('product-info') || form.closest('section');
    var box = scope && scope.querySelector('[data-artwork-upload]');
    if (!box || blank(imprint(scope))) return;
    var session = sessions.get(box.dataset.productId), art = session && session.getState().artwork;
    if (!art) return;
    var props = {'Artwork File': art.name, '_artwork_url': art.url, '_design_id': art.designId};
    Object.keys(props).forEach(function (k) {
      var n = doc.createElement('input'); n.type = 'hidden'; n.name = 'properties['+k+']'; n.value = props[k];
      n.setAttribute('data-artwork-property',''); form.appendChild(n);
    });
  }, true);
  doc.addEventListener('change', repaint);
  function start() {
    mount();
    new MutationObserver(function (records) {
      if (!records.some(function (r) { return Array.from(r.addedNodes).some(function (n) {
        return n.nodeType === 1 && (n.matches('[data-artwork-upload], product-info, form') || n.querySelector('[data-artwork-upload], form'));
      }); }) || scheduled) return;
      scheduled = true; queueMicrotask(function () { scheduled = false; mount(); });
    }).observe(doc.body, {subtree:true,childList:true});
  }
  global.ArtworkDawn = {mount:mount, isBlank:blank};
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded',start); else start();
}(window, document));
